'use client';

import { c as _c } from "react/compiler-runtime";
import { INITIATIVE_TYPE_CONFIG, type InitiativeType } from '@sizzlenz/shared';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
interface InitiativeTypeSelectorProps {
  value: InitiativeType | '';
  onValueChange: (value: InitiativeType) => void;
  disabled?: boolean;
  showDescription?: boolean;
}
export function InitiativeTypeSelector(t0) {
  const $ = _c(13);
  const {
    value,
    onValueChange,
    disabled,
    showDescription: t1
  } = t0;
  const showDescription = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <label className="block text-sm font-medium text-gray-700 mb-2">Initiative Type</label>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectTrigger className="w-full"><SelectValue placeholder="Select a type..." /></SelectTrigger>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SelectContent>{Object.entries(INITIATIVE_TYPE_CONFIG).map(_temp)}</SelectContent>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== disabled || $[4] !== onValueChange || $[5] !== value) {
    t5 = <div>{t2}<Select value={value} onValueChange={onValueChange} disabled={disabled}>{t3}{t4}</Select></div>;
    $[3] = disabled;
    $[4] = onValueChange;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== showDescription || $[8] !== value) {
    t6 = showDescription && value && INITIATIVE_TYPE_CONFIG[value]?.description && <div className="p-4 bg-gray-50 rounded-lg"><h3 className="font-medium mb-2">{INITIATIVE_TYPE_CONFIG[value].label}</h3><p className="text-sm text-gray-600">{INITIATIVE_TYPE_CONFIG[value].description}</p></div>;
    $[7] = showDescription;
    $[8] = value;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="space-y-4">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp(t0) {
  const [type, config] = t0;
  return <SelectItem key={type} value={type}><div className="flex items-center gap-2"><span className={`px-2 py-0.5 rounded text-xs ${config.color}`}>{config.label}</span></div></SelectItem>;
}